<template>
  <div
    :style="
      clientStore.getCustomBackgroundImagePath !== null
        ? 'background-image: url(' +
          clientStore.getCustomBackgroundImagePath +
          '); '
        : ''
    "
    :class="{
      'custom-background-image':
        clientStore.getCustomBackgroundImagePath !== null,
    }"
  >
    <BackgroundBubbles
      v-if="clientStore.getCustomBackgroundImagePath === null"
    />
    <div
      class="m-auto h-screen max-w-7xl flex justify-center align-middle flex-col"
    >
      <div class="text-4xl text-white mx-auto mb-8">
        {{ $t("ssosbk.enternewpassword.info.title") }}
      </div>
      <div v-if="!isSetNewPassword" class="mx-auto mb-10 text-xl font-bold">
        {{ $t("ssosbk.enternewpassword.info.text") }}
      </div>

      <div class="text-xl mx-auto flex flex-col">
        <input
          v-if="!isSetNewPassword"
          v-model="password"
          placeholder="Passwort"
          type="password"
          required
          class="input-primary w-96 m-auto"
          @input="validate"
        />
        <input
          v-if="!isSetNewPassword"
          v-model="password2"
          placeholder="Passwort wiederholen"
          type="password"
          required
          class="input-primary mt-4 w-96 m-auto"
          @input="validate"
        />
        <p v-if="errorStrength" class="my-4 text-xl text-red-800 font-bold">
          Das Passwort muss mindestens acht Zeichen lang sein, mindestens eine
          Zahl, ein Sonderzeichen sowie ein Groß- und Kleinbuchstaben enthalten.
          Bitte verwenden Sie kein Passwort, das Sie als Login innerhalb Ihres
          Unternehmens verwenden.
        </p>
        <p v-if="errorSame" class="my-4 text-xl text-red-800 font-bold">
          Passwörter müssen übereinstimmen.
        </p>
        <div
          v-if="!isSetNewPassword"
          class="cursor-pointer mt-2 w-95 mx-auto col-span-2 button-bkk-100 mt-4 text-center !text-background"
          @click="sendNewPassword()"
        >
          {{ $t("ssosbk.enternewpassword.button.text") }}
        </div>
        <div v-else>
          <div class="text-4xl mx-auto mb-8 text-center">
            {{ $t("ssosbk.enternewpassword.success.title") }}
          </div>
          <div class="text-xl font-bold mx-auto text-center">
            <span v-if="clientStore.getPasswordResetRedirectTarget === 'login'">
              {{ $t("ssosbk.enternewpassword.success.text") }}
            </span>
            <span v-else>
              {{ $t("ssosbk.enternewpassword.registration.success.text") }}
            </span>
          </div>

          <div class="text-xl mx-auto mt-8">
            <div
              class="cursor-pointer mt-2 w-96 mx-auto col-span-2 button-bkk-100 text-center !text-background"
              @click="redirectAfterSuccess()"
            >
              <span
                v-if="clientStore.getPasswordResetRedirectTarget === 'login'"
              >
                {{
                  $t("ssosbk.enternewpassword.success.button.loginforward.text")
                }}
              </span>
              <span v-else>
                {{
                  $t(
                    "ssosbk.enternewpassword.success.button.registerforward.text"
                  )
                }}
              </span>
            </div>

            <div
              v-if="clientStore.getPasswordResetRedirectTarget !== 'register'"
              class="text-xl font-bold mx-auto text-center mt-8 mb-8"
            >
              <span>
                {{ $t("ssosbk.enternewpassword.success.textregister") }}
              </span>
            </div>

            <div
              v-if="clientStore.getPasswordResetRedirectTarget !== 'register'"
              class="cursor-pointer mt-2 w-96 mx-auto col-span-2 button-bkk-100 text-center !text-background"
              @click="redirectToRegister()"
            >
              <span>
                {{
                  $t(
                    "ssosbk.enternewpassword.success.button.registerredirect.text"
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterLinks bg-fixed />
  </div>
</template>

<script>
import BackgroundBubbles from "../../../components/v2/layout/BackgroundBubbles.vue";
import { setNewPassword } from "../../../api/sbk";
import { useClientStore } from "../../../store/v2/client";
import FooterLinks from "../../../components/v2/sbk/FooterLinks.vue";
import { SBK_BLUE } from "../../../enum/v2/sbk";

export default {
  name: "ActivationPage",
  components: { FooterLinks, BackgroundBubbles },
  setup() {
    const clientStore = useClientStore();
    return {
      clientStore,
    };
  },
  data() {
    return {
      activationStatusError: [],
      isSetNewPassword: false,
      resetMail: null,
      errorStrength: null,
      errorSame: null,
      password: null,
      password2: null,
      tokenExtracted: null,
    };
  },
  async mounted() {
    const params = this.$route.params;
    if (
      params.atmCampaign &&
      params.atmCampaign.length > 0 &&
      params.atmCampaign != "-"
    ) {
      this.client = await this.clientStore.getClient(null, params.atmCampaign);
    }

    this.tokenExtracted = params.token;
    this.clientStore.setClientColorsManually(
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE
    );
  },
  methods: {
    sendNewPassword() {
      if (!this.areSamePasswords()) {
        this.errorSame = true;
        return;
      }

      if (!this.isStrongEnough(this.password)) {
        this.errorStrength = true;
        return;
      }

      this.isSetNewPassword = true;
      this.errorSame = false;
      this.errorStrength = false;

      setNewPassword(this.tokenExtracted, this.password);
    },
    validate(event) {
      if (!this.isStrongEnough(event.target.value)) {
        this.errorSame = false;
        this.errorStrength = true;
        return false;
      }
      this.errorStrength = false;

      if (!this.areSamePasswords()) {
        this.errorSame = true;

        return false;
      }
      this.errorSame = false;

      return true;
    },
    isStrongEnough(value) {
      // allow special characters based on SKB's ATM system
      const regex =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!§$%()\[\]{}?ß#‘^°~@,\-=*.:\/_+&;<>"])[A-Za-z0-9!§$%()\[\]{}?ß#‘^°~@,\-=*.:\/_+&;<>]{8,}/;

      return value.length <= 3 || regex.test(value);
    },
    areSamePasswords() {
      return (
        this.password !== null &&
        this.password2 !== null &&
        this.password === this.password2
      );
    },
    redirectAfterSuccess() {
      if (this.clientStore.getPasswordResetRedirectTarget === "login") {
        this.$router.push({
          name: "sbkLogin",
          params: {
            atmCampaign: this.clientStore.atmCampaign,
          },
        });
      } else {
        this.$router.push({
          name: "sbkRegister",
          params: {
            atmCampaign: this.clientStore.atmCampaign,
          },
        });
      }
    },
    redirectToRegister() {
      this.$router.push({
        name: "sbkRegister",
        params: {
          atmCampaign: this.$route.params.atmCampaign,
        },
      });
    },
  },
};
</script>
